import DataGrid, {
    Column,
    Paging
} from "devextreme-react/data-grid";
import { useEffect, useState } from "react";
import axios from "axios";
import attachmentService, { SysFile } from "./attachmentService";
import apiUrl from "../../configs/constant";
import { useToast } from "../ToastProvider";

interface Props {
    docId: number | string;
    docType: string;
}

const AttachmentGrid: React.FC<Props> = ({ docId, docType }) => {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const token = userData.token
    const { showToast, hideToast } = useToast();

    const [data, setData] = useState<SysFile[]>([]);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [loading, setLoading] = useState(false);

    const loadData = async () => {
        const result = await attachmentService.getFiles(docId, docType);
        setData(result);
    };

    useEffect(() => {
        loadData();
    }, [docId, docType]);

    const handleUpload = async () => {
        if (!selectedFile) {
            alert("Pilih file dulu");
            return;
        }

        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("doc_id", docId.toString());
        formData.append("doc_type", docType);

        try {
            setLoading(true);

            const url = apiUrl.apiUrl + '/system/attachment/upload'
            axios
                .post(url, formData, {
                    headers: { Authorization: `Bearer ${token}` }
                })
                .then(response => {
                    if (response.data.success) {
                        showToast('Upload File Berhasil', 'success');

                        setSelectedFile(null);
                        // reset input file
                        const fileInput = document.querySelector(
                            'input[type="file"]'
                        ) as HTMLInputElement;

                        if (fileInput) {
                            fileInput.value = "";
                        }
                        loadData();
                    } else {
                        showToast(response.data.message, 'error');
                    }
                })
                .catch(error => {
                    showToast(error.message, 'error');
                    alert(error.message);
                })

        } catch (error: any) {
            alert("Upload gagal");
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id: number) => {
        await attachmentService.deleteFile(id);
        loadData();
    };

    return (
        <>
            {/* UPLOAD SECTION */}
            <div
                style={{
                    marginBottom: 20,
                    padding: 16,
                    border: "1px solid #e0e0e0",
                    borderRadius: 8,
                    display: "flex",
                    alignItems: "center",
                    gap: 12,
                    backgroundColor: "#fafafa"
                }}
            >
                <label
                    style={{
                        padding: "8px 14px",
                        backgroundColor: "#1976d2",
                        color: "white",
                        borderRadius: 6,
                        cursor: "pointer",
                        fontSize: 14
                    }}
                >
                    Choose File
                    <input
                        type="file"
                        style={{ display: "none" }}
                        onChange={(e) => {
                            if (e.target.files && e.target.files[0]) {
                                setSelectedFile(e.target.files[0]);
                            }
                        }}
                    />
                </label>

                {/* File Name */}
                <span style={{ flex: 1, fontSize: 14, color: "#555" }}>
                    {selectedFile ? selectedFile.name : "No file selected"}
                </span>

                <button
                    onClick={handleUpload}
                    disabled={!selectedFile || loading}
                    style={{
                        padding: "8px 16px",
                        backgroundColor: loading || !selectedFile ? "#bdbdbd" : "#4caf50",
                        color: "white",
                        border: "none",
                        borderRadius: 6,
                        cursor: loading || !selectedFile ? "not-allowed" : "pointer"
                    }}
                >
                    {loading ? "Uploading..." : "Upload"}
                </button>
            </div>


            {/* GRID */}
            {/* <DataGrid
                dataSource={data}
                showBorders
            >
                <Paging defaultPageSize={10} />

                <Column
                    dataField="server_link"
                    caption="File"
                    cellRender={(cell: any) => (
                        <a href={cell.value} target="_blank" rel="noreferrer">
                            Open File
                        </a>
                    )}
                />

                <Column dataField="jenis_file" caption="Type" />
                <Column dataField="created_at" caption="Uploaded At" />

                <Column
                    type="buttons"
                    width={80}
                    buttons={[
                        {
                            hint: "Delete",
                            icon: "trash",
                            onClick: (e: any) => handleDelete(e.row.data.id)
                        }
                    ]}
                />
            </DataGrid> */}
            {/* FILE LIST */}
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
                    gap: 16
                }}
            >
                {data.map((item) => {
                    const ext = item.jenis_file.toLowerCase();
                    const isImage = ["jpg", "jpeg", "png", "gif", "webp"].includes(ext);

                    return (
                        <div
                            key={item.id}
                            style={{
                                border: "1px solid #e0e0e0",
                                borderRadius: 10,
                                padding: 10,
                                background: "#fff",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
                                position: "relative",
                                cursor: "pointer",
                                transition: "0.2s"
                            }}
                            onClick={() => window.open(item.server_link, "_blank")}
                        >
                            {/* DELETE BUTTON */}
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleDelete(item.id);
                                }}
                                style={{
                                    position: "absolute",
                                    top: 6,
                                    right: 6,
                                    border: "none",
                                    background: "#ff5252",
                                    color: "white",
                                    borderRadius: "50%",
                                    width: 24,
                                    height: 24,
                                    cursor: "pointer",
                                    fontSize: 12
                                }}
                            >
                                ✕
                            </button>

                            {/* FILE PREVIEW */}
                            <div
                                style={{
                                    height: 120,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginBottom: 8,
                                    overflow: "hidden",
                                    borderRadius: 8,
                                    background: "#f5f5f5"
                                }}
                            >
                                {isImage ? (
                                    <img
                                        src={item.server_link}
                                        alt="preview"
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover"
                                        }}
                                    />
                                ) : (
                                    <div style={{ fontSize: 40 }}>📄</div>
                                )}
                            </div>

                            {/* FILE INFO */}
                            <div style={{ fontSize: 12, color: "#555" }}>
                                <div style={{ fontWeight: 500 }}>
                                    {ext.toUpperCase()}
                                </div>
                                <div>
                                    {new Date(item.created_at).toLocaleDateString()}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>

        </>
    );
};

export default AttachmentGrid;
